<template>
  <div class="socials" v-if="content">
    <h2 class="title-font socials-title">{{title}}</h2>
    <ul>
      <li v-for="(s,i) in content" :key="i">
        <a :href="s.content.link || '#'" target="_blank">
          <img class="social-icon" :src="s.content.img">
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    title: ""
  },
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      api
        .get(`cdn/stories?starts_with=${this.$i18n.locale}/socials`)
        .then(res => {
          this.content = res.data.stories;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss">
.socials {
  padding: 50px 0;

  .socials-title {
    text-align: center;
    color: #fff;
    padding: 20px 0;
  }
  > ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    > li {
      padding: 20px 30px;
      .social-icon {
        width: 50px;
        height: auto;
        margin: auto;
        transition: transform 0.4s ease-in-out;
        transform: scale(1) translateZ(0);
        backface-visibility: hidden;
        perspective: 1000;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}

@media screen and (max-width: 980px) {
  .socials {
    > ul {
      > li {
        padding: 5px 15px;
        .social-icon {
          width: 35px;
          height: auto;
        }
      }
    }
  }
}
</style>
